export default __webpack_public_path__ + "static/ek-8ee58e08cc5f11078b696569f0528b8a.jpg";